/* Electrodose: external copy of an inline script. The Liquid file sets window.edoseNavCartConfig and calls edoseInitNavCart. */
window.edoseInitNavCart = function () {
  var CFG = window.edoseNavCartConfig || {};
  if (window.__edoseCartDrawerInit) return;
  window.__edoseCartDrawerInit = true;


  var drawer       = document.getElementById('edCartDrawer');
  var backdrop     = document.getElementById('edDrawerBackdrop');
  var closeBtn     = document.getElementById('edCartClose');
  var itemsEl      = document.getElementById('edCartItems');
  var emptyEl      = document.getElementById('edCartEmpty');
  var footerEl     = document.getElementById('edCartFooter');
  var titleCountEl = document.getElementById('edCartTitleCount');
  var subtotalEl   = document.getElementById('edCartSubtotal');
  var savingsRow   = document.getElementById('edCartSavingsRow');
  var savingsEl    = document.getElementById('edCartSavings');
  var shipNoteEl = document.getElementById('edCartShippingNote');
  /* Temporary sale (2026-10-11): sale / regular shipping sentences, present only while they differ */
  var shipRuleEl = document.getElementById('edCartShipRule');
  var shipAmountEl = document.getElementById('edCartShippingAmount');
  var totalEl = document.getElementById('edCartTotal');
  var shippingRow = document.getElementById('edCartShippingRow');
  var totalRow = document.getElementById('edCartTotalRow');
  var checkoutEl = document.getElementById('edCartCheckout');
  var cartRenderVersion = 0;
  var cartUpdatePending = false;
  var SHIPPING_RULE = CFG.shippingRule;
  var REGULAR_RULE = CFG.regularRule;
  if (!drawer || !backdrop) return;

  /* Shop money format, e.g. the amount placeholder wrapped in the currency symbol */
  var MONEY_FORMAT = CFG.moneyFormat;
  /* Shipping figures from the theme settings, in cents; null = not set */
  var SHIP_SINGLE = CFG.shipSingle;
  var SHIP_FREE_MIN = CFG.shipFreeMin;
  /* Temporary sale (2026-10-11): label = settings.edose_sale_label (finds sale lines by discount title);
     shipCents = the sale shipping while the sale is on, else null (regular rule) */
  var SALE = CFG.sale;
  var TUB_HANDLE = CFG.tubHandle;
  var welcomeKey = '';
  function isSaleLine(item){
    if (!SALE.label) return false;
    var a = (item && item.line_level_discount_allocations) || [];
    for (var i = 0; i < a.length; i++) {
      var t = String(((a[i] || {}).discount_application || {}).title || '');
      if ((parseInt(a[i].amount, 10) || 0) > 0 && t.indexOf(SALE.label) !== -1) return true;
    }
    return false;
  }
  /* Commitment wording per pack, from snippets/edose-sub-terms (follows the edose_sub.min_cycles_* metafields) */
  var SUB_TERMS = {};
  SUB_TERMS[CFG.tubHandle] = CFG.cancelSingle;
  SUB_TERMS[CFG.tripleHandle] = CFG.cancelTriple;

  function groupThousands(intPart, sep){
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatAmount(cents, decimals, thousands, point){
    var parts = (cents / 100).toFixed(decimals).split('.');
    return groupThousands(parts[0], thousands) + (parts[1] ? point + parts[1] : '');
  }
  function money(cents){
    cents = parseInt(cents, 10) || 0;
    var sign = cents < 0 ? '-' : '';
    if (cents < 0) cents = -cents;
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    var m = ph.exec(MONEY_FORMAT || '');
    if (!m) return sign + '$' + formatAmount(cents, 2, ',', '.');
    var out;
    switch (m[1]) {
      case 'amount_no_decimals': out = formatAmount(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = formatAmount(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = formatAmount(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = formatAmount(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = formatAmount(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': out = formatAmount(cents, 2, ' ', ','); break;
      default: out = formatAmount(cents, 2, ',', '.');
    }
    return sign + MONEY_FORMAT.replace(ph, function(){ return out; });
  }

  function escapeHtml(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function openDrawer(){
    drawer.classList.add('open');
    backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    // Always pull fresh cart when opening
    if (!cartUpdatePending) renderCart().catch(function(){});
  }
  function closeDrawer(){
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }
  window.edoseOpenCart = openDrawer;
  window.edoseCloseCart = closeDrawer;
  if (checkoutEl) checkoutEl.addEventListener('click', function(event){
    if (cartUpdatePending) event.preventDefault();
  });

  backdrop.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  // Auto-open on cart add (fired by the badge-updater interceptor)
  document.addEventListener('edose:cart-added', openDrawer);


  /* ─── Subscription cadence label ───
     Cadence comes from the selling plan's first option value. The plan NAME is never printed
     (the app's plan names carry prices that do not match what checkout charges). No cadence = no label. */
  function subLabel(item){
    var alloc = item.selling_plan_allocation;
    var plan = alloc && alloc.selling_plan;
    if (!plan || !plan.options || !plan.options.length || !plan.options[0]) return null;
    var v = String(plan.options[0].value || '').replace(/^\s+|\s+$/g, '');
    v = v.replace(/^(deliver\s+)?every\s+/i, '');
    if (!v || /[$%]/.test(v)) return null;
    return 'Every ' + v;
  }

  /* Renewal price of a two-tier plan (first delivery cheaper than the rest), per unit, else 0 */
  function subRecurring(item){
    var alloc = item.selling_plan_allocation;
    var adj = alloc && alloc.price_adjustments;
    if (!adj || adj.length < 2) return 0;
    var last = parseInt(adj[adj.length - 1].price, 10) || 0;
    var first = parseInt(alloc.price, 10) || 0;
    return (last > 0 && last !== first) ? last : 0;
  }

  /* Number of deliveries charged the first price of a two-tier plan (funnel fix v5, F06).
     1. the line's own plan in the cart JSON (selling_plan.price_adjustments[0].order_count),
     2. else the offer data on the page, by plan id (introCount),
     3. else 0 = not known: the sentence then says "Introductory price", true for every count. */
  function subIntroCount(item){
    var alloc = item.selling_plan_allocation;
    var plan = alloc && alloc.selling_plan;
    if (!plan) return 0;
    var adj = plan.price_adjustments;
    var n = (adj && adj.length && adj[0]) ? parseInt(adj[0].order_count, 10) : 0;
    if (n > 0) return n;
    try {
      var el = document.querySelector('script.edose-offer-data');
      var data = el ? JSON.parse(el.textContent || el.innerHTML || '') : null;
      var packs = (data && data.packs) || {};
      for (var k in packs) {
        if (!Object.prototype.hasOwnProperty.call(packs, k) || !packs[k]) continue;
        var plans = packs[k].plans || [];
        for (var i = 0; i < plans.length; i++) {
          if (String(plans[i].id) === String(plan.id)) {
            n = parseInt(plans[i].introCount, 10);
            return n > 0 ? n : 0;
          }
        }
      }
    } catch (e) {}
    return 0;
  }

  /* Price sentence of a two-tier subscription line. `recurring` = renewal price per unit.
     One introductory delivery keeps the sentence this drawer always printed. With more
     than one (or an unknown number) the introductory price is the line price BEFORE
     discounts, because a discount on the first delivery says nothing about the next one. */
  function subPriceSentence(item, recurring){
    var n = subIntroCount(item);
    var charged = item.final_line_price || item.line_price || 0;
    var then = ', then ' + escapeHtml(money(recurring * item.quantity)) + ' per delivery';
    if (n === 1) return 'First delivery ' + escapeHtml(money(charged)) + then;
    var intro = item.original_line_price || charged;
    var introMoney = escapeHtml(money(intro));
    if (intro > charged) {
      return 'First delivery ' + escapeHtml(money(charged)) + ' after discounts. Before discounts: ' +
        (n > 1 ? 'first ' + n + ' deliveries ' + introMoney + ' each' : 'introductory price ' + introMoney) + then;
    }
    return (n > 1 ? 'First ' + n + ' deliveries ' + introMoney + ' each' : 'Introductory price ' + introMoney) + then;
  }

  /* Commitment wording for a subscription line (tub / 3-pack only), trusted theme output */
  function subTerms(item){
    if (!item.selling_plan_allocation) return '';
    var t = SUB_TERMS[item.handle];
    return typeof t === 'string' ? t : '';
  }

  /* ─── Render a single item ─── */
  function renderItem(item){
    var img = item.image || item.featured_image && item.featured_image.url || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.replace(/(\.[a-z]+)(\?.*)?$/i, function(m0, ext, query){ return '_180x' + ext + (query || ''); });

    var title = item.product_title || item.title || 'Item';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var sub = subLabel(item);
    var hasDiscount = item.original_line_price && item.final_line_price && item.original_line_price > item.final_line_price;
    /* Compare-at anchor for lines the Ajax cart cannot describe: window.edoseCompareAt = { variantId: cents } */
    var cmpUnit = parseInt((window.edoseCompareAt || {})[item.variant_id], 10) || 0;
    var wasPrice = hasDiscount ? item.original_line_price : (cmpUnit > (item.final_price || item.price || 0) ? cmpUnit * item.quantity : 0);

    var metaParts = [];
    if (variant) metaParts.push('<span>' + escapeHtml(variant) + '</span>');
    /* The free gift belongs to the subscription: on a one-time line the property is not printed (same rule as the cart page) and cleanStaleGift takes it off the cart. */
    var giftShown = item.handle === 'electrodose-electrolyte-powder-3-pack-berry-lemonade-90-servings';
    if (item.properties) { Object.keys(item.properties).forEach(function (k) { var v = item.properties[k]; if (k && k.charAt(0) !== '_' && v && k !== 'Welcome items' && (giftShown || k !== 'Free gift')) { metaParts.push('<span>\uD83C\uDF81 ' + escapeHtml(k) + ': ' + escapeHtml(String(v)) + '</span>'); } }); }
    var metaHTML = metaParts.length ? '<p class="ed-cart-item__meta">' + metaParts.join('<br>') + '</p>' : '';
    var subHTML = sub ? '<span class="ed-cart-item__sub">' + escapeHtml(sub) + '</span>' : '';
    /* Frequency and subscription terms only when this line has a selling plan. */
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      var termParts = [];
      var recurring = subRecurring(item);
      if (recurring) termParts.push(subPriceSentence(item, recurring));
      /* Flat plan with the sale on its first delivery (2026-10-11): the renewal price, as the cart page says it */
      else if (isSaleLine(item) && item.final_line_price < item.original_line_price) termParts.push('First delivery ' + escapeHtml(money(item.final_line_price)) + ' after discounts, then ' + escapeHtml(money((parseInt(item.selling_plan_allocation.price, 10) || 0) * item.quantity)) + ' per delivery before discounts');
      var terms = subTerms(item);
      if (terms) termParts.push((terms.charAt(0).toUpperCase() + terms.slice(1)).replace(/[.\s]+$/, ''));
      if (termParts.length) subHTML += '<span class="ed-cart-item__terms">' + termParts.join('. ') + '.</span>';
      /* Free gift of a subscription line (funnel fix v5, F02): it can be the default gift, so the line says how to get another one */
      if (item.properties && item.properties['Free gift']) {
        subHTML += '<span class="ed-cart-item__terms">' + escapeHtml(CFG.editInCart) + '</span>';
      }
      /* Single-tub subscription welcome items (2026-10-11), first tub subscription line only (the cart page's rule) */
      if (item.key === welcomeKey) {
        subHTML += '<span class="ed-cart-item__terms">Includes 1 welcome box + 1 plastic water bottle with this first delivery (one set per order).</span>';
      }
    }
    /* Discounts on this line (funnel fix v2): an automatic discount is named next to the
       discounted price. A code the shopper typed is not repeated, only acknowledged. */
    var discParts = [];
    var discAllocs = item.line_level_discount_allocations || [];
    for (var di = 0; di < discAllocs.length; di++) {
      var discAlloc = discAllocs[di] || {};
      var discApp = discAlloc.discount_application || {};
      var discAmount = parseInt(discAlloc.amount, 10) || 0;
      if (discAmount > 0) {
        var discName = discApp.type === 'discount_code' ? 'Discount code' : String(discApp.title || 'Discount');
        discParts.push(escapeHtml(discName) + ': \u2212' + escapeHtml(money(discAmount)));
      }
    }
    if (discParts.length) subHTML += '<span class="ed-cart-item__terms ed-cart-item__disc">' + discParts.join('<br>') + '</span>';

    return [
      '<div class="ed-cart-item" data-key="' + escapeHtml(item.key) + '">',
        '<div class="ed-cart-item__image">',
          img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '',
        '</div>',
        '<div class="ed-cart-item__body">',
          '<h3 class="ed-cart-item__title">' + escapeHtml(title) + '</h3>',
          metaHTML,
          subHTML,
          '<div class="ed-cart-item__controls" role="group" aria-label="Quantity">',
            '<button class="ed-cart-item__qty-btn ed-qty-dec" type="button" aria-label="Decrease quantity">−</button>',
            '<span class="ed-cart-item__qty">' + item.quantity + '</span>',
            '<button class="ed-cart-item__qty-btn ed-qty-inc" type="button" aria-label="Increase quantity">+</button>',
          '</div>',
        '</div>',
        '<div class="ed-cart-item__right">',
          '<button class="ed-cart-item__remove ed-remove" type="button" aria-label="Remove item">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>',
          '</button>',
          '<div class="ed-cart-item__price">',
            wasPrice ? '<span class="ed-vh">was </span><span class="ed-cart-item__price-was">' + money(wasPrice) + '</span><span class="ed-vh">, now </span>' : '',
            money(item.final_line_price || item.line_price || 0),
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  /* ─── One-time line that still carries the free gift (funnel fix v5, second pass) ───
     The gift belongs to the subscription. A plan change on the cart page that stopped half way can
     leave the property on a one-time line; this drawer's Checkout button does not pass the cart page,
     so the property is taken off the cart here: same request as the cart page (the key is sent with
     a blank value, quantity and every other property unchanged). One line per rendering, one request
     per line key, at most four per page view, nothing on the cart page (it cleans its own lines).
     A failed request changes nothing and is not repeated. */
  var giftCleanTried = {};
  var giftCleanLeft = 4;
  function cleanStaleGift(cart){
    if (window.location.pathname.indexOf('/cart') === 0) return;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var line = items[i];
      if (line.handle === 'electrodose-electrolyte-powder-3-pack-berry-lemonade-90-servings' || !line.properties || !line.properties['Free gift']) continue;
      if (giftCleanLeft <= 0 || giftCleanTried[line.key]) continue;
      giftCleanTried[line.key] = true;
      giftCleanLeft--;
      var props = {};
      for (var k in line.properties) {
        if (Object.prototype.hasOwnProperty.call(line.properties, k)) props[k] = line.properties[k];
      }
      props['Free gift'] = '';
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
      })
      .then(function(r){ if (r && r.ok) return renderCart(); })
      .catch(function(){});
      return;
    }
  }

  /* ─── Render the full cart ─── */
  function renderCart(){
    var version = ++cartRenderVersion;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function(r){ if (!r.ok) throw new Error('Cart request failed'); return r.json(); })
      .then(function(cart){
        if (version !== cartRenderVersion) return;
        var count = cart.item_count || 0;
        titleCountEl.textContent = count > 0 ? ' · ' + count : '';

        if (count === 0) {
          if (emptyEl) emptyEl.style.display = '';
          itemsEl.querySelectorAll('.ed-cart-item').forEach(function(el){ el.remove(); });
          footerEl.style.display = 'none';
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        footerEl.style.display = '';

        welcomeKey = '';
        for (var wi = 0; wi < cart.items.length; wi++) {
          if (cart.items[wi].handle === TUB_HANDLE && cart.items[wi].selling_plan_allocation) { welcomeKey = cart.items[wi].key; break; }
        }
        var html = cart.items.map(renderItem).join('');
        // Replace items but keep the empty element node in DOM (just hidden)
        itemsEl.querySelectorAll('.ed-cart-item').forEach(function(el){ el.remove(); });
        itemsEl.insertAdjacentHTML('beforeend', html);

        // Subtotal + savings
        subtotalEl.textContent = money(cart.total_price || 0);
        var savings = cart.total_discount || 0;
        if (savings > 0) {
          savingsRow.classList.remove('is-empty');
          savingsEl.textContent = '-' + money(savings);
        } else {
          savingsRow.classList.add('is-empty');
        }
        var hasSale = (cart.items || []).some(isSaleLine);
        var shipDisc = (cart.cart_level_discount_applications || []).some(function (a) { return !!a && a.target_type === 'shipping_line'; });
        var universalFree = SHIP_SINGLE === 0 && (SHIP_FREE_MIN === null || SHIP_FREE_MIN <= 0);
        var shippingCents = null;
        if (!cart.requires_shipping) { shippingCents = 0; }
        else if (universalFree) { shippingCents = 0; }
        else if (!shipDisc && hasSale && SALE.freeMinCents !== null && cart.total_price >= SALE.freeMinCents) { shippingCents = 0; }
        else if (!shipDisc && hasSale && SALE.shipCents !== null) { shippingCents = SALE.shipCents; }
        else if (!shipDisc && SHIP_FREE_MIN !== null && cart.total_price >= SHIP_FREE_MIN && !cart.total_discount) { shippingCents = 0; }
        else if (!shipDisc && SHIP_SINGLE !== null) { shippingCents = SHIP_SINGLE; }
        if (shippingRow) { shippingRow.hidden = !cart.requires_shipping; }
        if (totalRow) { totalRow.hidden = shippingCents === null; }
        if (shipAmountEl) { shipAmountEl.textContent = shippingCents === null ? (shipDisc ? CFG.shippingDiscountAtCheckout : CFG.calculatedAtCheckout) : money(shippingCents); }
        if (totalEl && shippingCents !== null) {
          totalEl.textContent = money((cart.total_price || 0) + shippingCents);
          totalEl.setAttribute('data-shipping-cents', shippingCents);
          totalEl.setAttribute('data-display-total', (cart.total_price || 0) + shippingCents);
        }
        if (totalEl && shippingCents === null) {
          totalEl.textContent = '';
          totalEl.removeAttribute('data-shipping-cents');
          totalEl.removeAttribute('data-display-total');
        }
        if (shipNoteEl) { shipNoteEl.textContent = shippingCents === null ? CFG.shippingAndTaxesAtCheckout : CFG.taxesAtCheckout; }
        if (shipRuleEl) { shipRuleEl.textContent = hasSale && SALE.shipCents !== null ? SHIPPING_RULE : REGULAR_RULE; }



        // Wire up item-level controls
        itemsEl.querySelectorAll('.ed-cart-item').forEach(function(row){
          var key = row.getAttribute('data-key');
          row.querySelector('.ed-qty-dec').addEventListener('click', function(){
            var q = parseInt(row.querySelector('.ed-cart-item__qty').textContent, 10) - 1;
            updateLine(key, Math.max(0, q), row);
          });
          row.querySelector('.ed-qty-inc').addEventListener('click', function(){
            var q = parseInt(row.querySelector('.ed-cart-item__qty').textContent, 10) + 1;
            updateLine(key, q, row);
          });
          row.querySelector('.ed-remove').addEventListener('click', function(){
            updateLine(key, 0, row);
          });
        });

        cleanStaleGift(cart);
      });
  }

  /* ─── Mutate a cart line via /cart/change.js ─── */
  function updateLine(key, quantity, row){
    if (cartUpdatePending) return;
    cartUpdatePending = true;
    cartRenderVersion++;
    footerEl.setAttribute('aria-busy', 'true');
    if (checkoutEl) {
      checkoutEl.setAttribute('aria-disabled', 'true');
      checkoutEl.classList.add('is-disabled');
    }
    itemsEl.querySelectorAll('button').forEach(function(button){ button.disabled = true; });
    if (row) row.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r){ if (!r.ok) throw new Error('Cart change failed'); return r.json(); })
    .then(function(){
      if (typeof window.edoseRefreshCartBadge === 'function') window.edoseRefreshCartBadge();
      return renderCart();
    })
    .catch(function(){
      if (row) row.style.opacity = '';
      return renderCart().catch(function(){});
    })
    .finally(function(){
      cartUpdatePending = false;
      footerEl.removeAttribute('aria-busy');
      itemsEl.querySelectorAll('button').forEach(function(button){ button.disabled = false; });
      if (checkoutEl) {
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.classList.remove('is-disabled');
      }
    });
  }

  // Initial render once on script load
  renderCart().catch(function(){});
};
